import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output
} from '@angular/core';
import {RecordData, RecordsDataRequestQueryParams} from "../../../../../types/records-table.types";
import {MatTab, MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {AdvertisementPackagesModalService} from "../../services/advertisement-packages-modal.service";
import {AttachProps} from "../../../../../types/attach-detach.types";
import {advertisementPackagesResourceType} from "../../configs/advertisement-packages-modal.config";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatListOption, MatSelectionList} from "@angular/material/list";
import {MatButton} from "@angular/material/button";
import {CloseModalReason} from "../../../../../types/modal.types";
import {defaultRecordsDataRequestQueryParams} from "../../../../../models/default-records-data-request-query-params";
import {ErrorService} from "../../../../../services/error.service";

@Component({
  selector: 'app-new-advertisement-packages',
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    MatFormField,
    MatInput,
    FormsModule,
    MatLabel,
    MatSelectionList,
    MatListOption,
    MatButton
  ],
  templateUrl: './new-advertisement-packages.component.html',
  styleUrl: './new-advertisement-packages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewAdvertisementPackagesComponent implements OnInit {
  recordData = input.required<RecordData>();
  onCloseDialog = output<CloseModalReason>();
  handleAttachData = output<AttachProps>();
  handleSetLoadingState = output<boolean>();

  private advertisementPackagesModalService: AdvertisementPackagesModalService = inject(AdvertisementPackagesModalService);
  private errorService: ErrorService = inject(ErrorService);

  public packageName: string = '';
  public selectedTabIndex: number = 0;
  public btnText: string = 'Добавить';
  public searchPackage: string = '';
  public packages: Array<RecordData> = [];
  public selectedPackages: Array<RecordData> = [];
  public hasPackages: boolean = false;
  private recordsDataRequestQueryParams: RecordsDataRequestQueryParams = defaultRecordsDataRequestQueryParams;

  public async ngOnInit(): Promise<void> {
    this.handleSetLoadingState.emit(true);
    await this.loadPackages();
  }

  public async loadPackages(): Promise<void> {
    this.recordsDataRequestQueryParams = {
      ...this.recordsDataRequestQueryParams,
      size: 100,
      search: this.searchPackage
    };

    this.packages = await this.advertisementPackagesModalService.getPackages(this.recordsDataRequestQueryParams)
      .catch(() => [])
      .finally(() => this.handleSetLoadingState.emit(false));
    this.hasPackages = !!this.packages.length;
  }

  public handleTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    this.btnText = this.selectedTabIndex ? 'Прикрепить' : 'Добавить';
  }

  public handleSelect(): void {
    const data = this.selectedPackages.at(0);
    if (!data) {
      this.errorService.showErrorMessage('Выберите рекламный пакет');
      return;
    }

    this.handleAttach(data);
  }

  public async handleCreate(): Promise<void> {
    await this.advertisementPackagesModalService.createPackage(this.packageName)
      .then(advertisementPackage => this.handleAttach(advertisementPackage));
  }

  private handleAttach(advertisementPackage: RecordData): void {
    const attachProps = this.setAttachProps(advertisementPackage);
    this.handleAttachData.emit(attachProps);
  }

  private setAttachProps(advertisementPackage: RecordData): AttachProps {
    return {
      path: advertisementPackagesResourceType.path,
      recordCalendarId: Number(this.recordData().id),
      id: Number(advertisementPackage.id)
    };
  }
}
